import { Box, Button, Skeleton, Typography } from "@mui/material";
import { t } from "i18next";
import { InfoIconWithTooltip } from "../../../../../../Title/InfoIcon";

/** display service item Image */
export const renderServiceImage = (
  size: number,
  picturePath?: string | null,
  setShowBiggerImage?: (image: string) => void
) => {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: "1rem" }}>
      {!picturePath && (
        <Skeleton variant={"rounded"} height={size} width={size} animation={false}>
          <Box width={size} height={size} sx={{ textAlign: "center", alignContent: "center" }}>
            <Typography variant={"body2"} sx={{ visibility: "visible" }}>
              {t("No Image")}
            </Typography>
          </Box>
        </Skeleton>
      )}
      {picturePath && (
        <Button
          sx={{ p: 0 }}
          variant={"text"}
          disabled={!setShowBiggerImage}
          onClick={e => {
            e.stopPropagation();
            setShowBiggerImage?.(picturePath);
          }}
          data-testid="show-bigger-image-btn"
        >
          <img
            src={picturePath} // ?? `https://picsum.photos/${size}/${size}`}
            height={size}
            width={size}
            loading="lazy"
            alt="service-item-image"
            style={{ borderRadius: "8px" }}
          />
        </Button>
      )}
    </Box>
  );
};

export const renderServiceBookingLeadTime = () => {
  return (
    <>
      {t("Booking Lead Time")}
      <InfoIconWithTooltip tooltipText={t("_ServiceBookingLeadTimeTooltip")} fontSize="1rem" />
    </>
  );
};

export const renderServiceSetupTime = () => {
  return (
    <>
      {t("Setup Time")}
      <InfoIconWithTooltip tooltipText={t("_ServiceSetupTimeTooltip")} fontSize="1rem" />
    </>
  );
};

export const renderItemStatus = (status: string) => <Typography>{status}</Typography>;
